// This file is auto-generated during build. Do not edit.

export interface Scan2SellConfig {
  VITE_CDN_URL: string;
  VITE_CDN_ID: string;
  VITE_JAMS_BACKEND_URL: string;
  VITE_JAMS_FRONTEND_URL: string;
  VITE_INVENTORY_API: string;
  VITE_JAMS_QR_API: string; // env-only
  VITE_UPLOAD_SERVICE_API_BASE_URL: string;
  VITE_COMPONENTS_BUCKET_NAME: string;
}

export const config: Scan2SellConfig = {
  VITE_CDN_URL: "https://d3h3nxtl6rlfz4.cloudfront.net",
  VITE_CDN_ID: "EWA0DBVP6VUNE",
  VITE_JAMS_BACKEND_URL: "https://api.sodasoft.io",
  VITE_JAMS_FRONTEND_URL: "https://jams.admin.sodasoft.io",
  VITE_INVENTORY_API: "https://25rjjq6lzc.execute-api.us-west-2.amazonaws.com/prod",
  VITE_JAMS_QR_API: "https://6bd3myq0ii.execute-api.us-west-2.amazonaws.com/prod/qr",
  VITE_UPLOAD_SERVICE_API_BASE_URL: "https://l5sihzfn26.execute-api.us-west-2.amazonaws.com",
  VITE_COMPONENTS_BUCKET_NAME: "jazel-lightning-components-prod",
};
